import React from 'react';
import { convertUrlsIntoLinks } from 'tools/helpers/string';

type TextWithLinksProps = {
	text: string;
	encode?: boolean;
	removeNewLines?: boolean;
};

export function TextWithLinks(props: TextWithLinksProps) {
	const html = React.useMemo(() => {
		return {
			__html: convertUrlsIntoLinks(props.text, {
				encodeSourceText: props.encode ?? true,
				removeNewLines: props.removeNewLines ?? false,
			}),
		};
	}, [props.text]);

	return <span title={props.text} dangerouslySetInnerHTML={html}></span>;
}
